import { keepPreviousData, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { bluebookQueryKeys } from '@p/a/client-report/hooks/queries/query-keys';

import { IClientReturns } from '@t/api/bluebook/client-return/client-return.model';
import { ReturnReportParameters } from '@t/api/bluebook/client-return/client-return-parameters.models';
import { IResult } from '@t/api/common';

import { returnServices } from 'services/returns.service';

export const createReturnReportQuery = (
  parameters: ReturnReportParameters
): UseQueryOptions<IResult<IClientReturns[]> | undefined, unknown, IClientReturns[] | undefined> => {
  return {
    placeholderData: keepPreviousData,
    queryFn: async () => await returnServices.getReturns(parameters),
    queryKey: bluebookQueryKeys.returns.clientReturns(parameters),
  };
};

export const useFetchClientReturns = (parameters: ReturnReportParameters) => {
  return useQuery(createReturnReportQuery(parameters));
};
